angular.module('SpidApp')

.factory('TransactionService',
[        'Transaction', 'Restangular',
function (Transaction,   Restangular) {
	var TransactionService = {
		all: function () {
			return Restangular.all('transactions').getList().then(function (transactionsData) {
				return _.map(transactionsData, function (transactionData) {
					return new Transaction(transactionData)
				})
			})
		},
        allWithSales: function () {
			return Restangular.all('transactions').getList('sales').then(function (transactionsData) {
				return _.map(transactionsData, function (transactionData) {
					return new Transaction(transactionData)
				})
			})
		},
		findByVacationId: function (agencyId, id) {
			if (agencyId === undefined || agencyId === null	||
				id === undefined || id === null) {
				throw 'TransactionService::findByVacationId() - Missing parameters'
			}

			return Restangular.one('agencies', agencyId).one('vacations', id).all('transactions').getList().then(function (transactionsData) {
				return _.map(transactionsData, function (transactionData) {
					return new Transaction(transactionData)
				})
			})
		},
		find: function (agencyId, id) {
			if (   agencyId === undefined || agencyId === null ||
				id === undefined || id === null) {
				throw 'TransactionService::find() - Missing parameters'
			}
			
			return Restangular.one('agencies', agencyId).one('transactions', id).get().then(function (transactionData) {
				return new Transaction(transactionData)
			})
		}
	}

	return TransactionService
}])
